import { render, staticRenderFns } from "./FilterSize.vue?vue&type=template&id=d8d6ed1c&"
import script from "./FilterSize.vue?vue&type=script&lang=js&"
export * from "./FilterSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports